module.exports = __webpack_public_path__ + "img/touristBehavior.fb62424e.png";